import { theme } from '../theme';

export const nivoTheme = {
  text: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSizes?.xs,
    fill: theme.colors?.gray?.[4],
  },
  axis: {
    ticks: {
      text: {
        fill: theme.colors?.gray?.[4],
      },
      line: {
        stroke: 'transparent',
      },
    },
    legend: {
      text: {
        fill: theme.colors?.gray?.[4],
        fontFamily: theme.fontFamily,
      },
    },
  },
  legends: {
    text: {
      fill: theme.colors?.gray?.[9],
      fontFamily: theme.fontFamily,
      fontSize: theme.fontSizes?.xs,
    },
  },
  grid: {
    line: {
      strokeWidth: 1.5,
      stroke: theme.colors?.gray?.[1],
      strokeOpacity: 1,
      strokeDasharray: '4',
    },
  },
  tooltip: {
    container: {
      background: 'white',
      color: 'black',
      fontSize: 'inherit',
      borderRadius: '2px',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
      padding: '5px 9px',
    },
    basic: {
      whiteSpace: 'pre',
      display: 'flex',
      alignItems: 'center',
    },
    table: {},
    tableCell: {
      padding: '3px 5px',
    },
  },
};
